(() => {
  'use strict';
  if (window.MayhemAnalytics) return;
  const config = JSON.parse(document.getElementById('mayhem-analytics-config').textContent);
  let configured = false;
  const disableKey = 'ga-disable-' + config.measurementId;
  window[disableKey] = true;
  let zeroKey = '';
  let filterValue;
  let searchZeroKey = '';
  const searchResults = () => {
    if (!allowed()) return;
    const finder = document.querySelector('[data-mayhem-wheel-finder]');
    if (finder && finder.dataset.searchResultsReady !== 'true') return;
    const count = finder ? Number(finder.dataset.searchResultCount) : config.searchEmpty ? 0 : null;
    const key = new URL(location.href).search;
    if (count === 0 && searchZeroKey !== key) {
      searchZeroKey = key;
      track('mayhem_zero_results', { source: 'search', result_count: 0 });
    } else if (count > 0) searchZeroKey = '';
  };
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const cleanPage = value => { try { const url = new URL(value); return url.origin + url.pathname; } catch { return ''; } };
  const consent = () => {
    const permitted = allowed();
    document.getElementById('mayhem-analytics-config').dataset.consent = permitted ? 'allowed' : 'denied';
    window[disableKey] = !permitted;
    if (!permitted) {
      try { sessionStorage.removeItem('mayhem:inquiry-pending'); } catch {}
      if (configured) window.gtag('consent', 'update', { analytics_storage: 'denied' });
      return;
    }
    if (configured) { window.gtag('consent', 'update', { analytics_storage: 'granted' }); return; }
    configured = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('js', new Date());
    window.gtag('config', config.measurementId, { ...(config.preview ? { debug_mode: true } : {}), page_location: cleanPage(location.href), page_referrer: cleanPage(document.referrer) });
    const script = document.createElement('script'); script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(config.measurementId); document.head.append(script);
    searchResults();
    inquirySuccess();
  };
  const parameters = new Set(['state', 'has_vehicle', 'filter_count', 'vehicle_id', 'vehicle_year', 'vehicle_make', 'vehicle_model', 'vehicle_trim', 'vehicle_body', 'vehicle_bed', 'vehicle_ymm', 'selection_location', 'variant_id', 'wheel_pn', 'configuration_count', 'enabled', 'result_count', 'source', 'color_id', 'ride_height', 'angle']);
  const events = new Set(['mayhem_dealer_details_copied', 'mayhem_fitment_unavailable', 'mayhem_vehicle_picker_abandoned', 'mayhem_support_failure', 'mayhem_search_recovery', 'mayhem_vehicle_selected', 'mayhem_zero_results', 'mayhem_direct_fit_filter', 'mayhem_visualizer_launch', 'mayhem_dealer_click', 'generate_lead', 'mayhem_setup_saved', 'mayhem_setup_shared', 'mayhem_setup_printed', 'mayhem_compare_added', 'mayhem_compare_opened', 'mayhem_visualizer_wheel', 'mayhem_visualizer_vehicle_color', 'mayhem_visualizer_ride_height', 'mayhem_visualizer_vehicle', 'mayhem_visualizer_vehicle_view', 'mayhem_visualizer_share']);
  const track = (event, details = {}) => {
    if (!events.has(event) || !allowed()) return;
    consent();
    const data = { ...(config.preview ? { debug_mode: true } : {}), page_location: cleanPage(location.href) };
    Object.entries(details).forEach(([key, value]) => { if (parameters.has(key) && value != null && ['string', 'number', 'boolean'].includes(typeof value)) data[key] = typeof value === 'string' ? value.slice(0, 100) : value; });
    window.gtag('event', event, data);
  };
  const vehicleSource = element => {
    if (!element?.closest) return 'vehicle_picker';
    const panel = element.closest('[data-mayhem-header-vehicle-panel]');
    if (panel?.mayhemOpener && panel.mayhemOpener !== element) return vehicleSource(panel.mayhemOpener);
    if (element.closest('#mayhem-support')) return 'support';
    if (element.closest('#Details-menu-drawer-container, .mayhem-header-vehicle-mobile')) return 'hamburger_menu';
    if (element.closest('.mayhem-setup-bar, [data-mayhem-mobile-vehicle-status]')) return 'toolbar';
    if (element.closest('[data-mmv]')) return 'visualizer';
    if (element.closest('[data-mayhem-home-lookup]')) return 'homepage_selector';
    if (element.closest('#header-group, #header-component')) return 'header';
    if (location.pathname.startsWith('/products/')) return 'product_page';
    if (location.pathname.startsWith('/collections/')) return 'collection_page';
    if (location.pathname === '/search') return 'search';
    if (element.closest('[data-mayhem-vehicle-lookup]')) return 'vehicle_lookup';
    return 'vehicle_picker';
  };
  let lastVehicleKey = '';
  let lastVehicleTime = 0;
  const vehicleSelected = (vehicle, source) => {
    if (!vehicle || !allowed()) return;
    const query = vehicle.query || vehicle;
    const label = String(vehicle.label || '').split(' · ');
    const year = query.year || label[0];
    const make = query.make || label[1];
    const model = query.model || label[2];
    if (!/^\d{4}$/.test(String(year)) || !make || !model) return;
    const trim = query.trimName || (vehicle.query ? label[3] : query.submodel) || '';
    const key = JSON.stringify([year, make, model, trim, query.body || '', query.bed || '']);
    if (key === lastVehicleKey && Date.now() - lastVehicleTime < 1000) return;
    lastVehicleKey = key;
    lastVehicleTime = Date.now();
    const data = {
      vehicle_year: String(year), vehicle_make: String(make), vehicle_model: String(model),
      vehicle_trim: String(trim), vehicle_ymm: [year, make, model].join(' '),
      source, selection_location: source
    };
    if (vehicle.id) data.vehicle_id = String(vehicle.id);
    if (query.body) data.vehicle_body = String(query.body);
    if (query.bed) data.vehicle_bed = String(query.bed);
    track('mayhem_vehicle_selected', data);
  };
  window.MayhemAnalytics = { track, vehicleSource };
  window.addEventListener('mayhem:vehicle-selected', event => vehicleSelected(event.detail?.vehicle, event.detail?.source || 'vehicle_picker'));
  document.addEventListener('visitorConsentCollected', consent);
  document.addEventListener('customerPrivacyApiLoaded', consent);
  window.addEventListener('load', consent, { once: true });
  window.addEventListener('mayhem:vehicle-changed', event => {
    const detail = event.detail;
    const locations = { header: 'header', lookup: location.pathname === '/' ? 'homepage_selector' : 'vehicle_lookup', support: 'support', 'mobile-visualizer': 'visualizer', 'saved-setup': 'saved_garage' };
    if (detail?.id && locations[detail.source]) vehicleSelected(detail.vehicle, detail.selection_location || locations[detail.source]);
    if (!detail?.id) lastVehicleKey = '';
    zeroKey = '';
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]'); if (!link) return;
    const url = new URL(link.href, location.origin);
    if (url.pathname.endsWith('/pages/dealers')) track('mayhem_dealer_click', { variant_id: url.searchParams.get('variant') || '', vehicle_id: url.searchParams.get('setup_vehicle') || '', source: link.dataset.setupDealer ? 'wheel_setup' : 'navigation' });
    if (link.matches('[data-mayhem-view-on-vehicle],[data-mayhem-card-view-on-vehicle]') || url.pathname.endsWith('/pages/visualizer')) track('mayhem_visualizer_launch', { source: link.closest('[data-mayhem-wheel-card]') ? 'collection' : 'product_or_navigation' });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-mayhem-direct-fit]')) return;
    filterValue = event.target.checked;
    track('mayhem_direct_fit_filter', { enabled: filterValue, source: 'filter' });
  });
  const results = () => {
    const tools = document.querySelector('[data-mayhem-collection-tools]'); if (!tools) return;
    const enabled = tools.dataset.directFitOnly === 'true';
    if (filterValue !== undefined && enabled !== filterValue) track('mayhem_direct_fit_filter', { enabled, source: 'chip_or_clear' });
    filterValue = enabled;
    if (tools.dataset.fitmentChecking === 'true' || document.documentElement.classList.contains('mayhem-fitment-only-loading')) return;
    const cards = [...document.querySelectorAll('[data-mayhem-wheel-card]')];
    if (!cards.length) return;
    const count = cards.filter(card => !card.closest('[hidden]')).length;
    const key = [enabled, count, new URL(location.href).search].join(':');
    if (count === 0 && key !== zeroKey) track('mayhem_zero_results', { result_count: 0, source: 'collection' });
    zeroKey = key;
  };
  let resultTimer;
  ['mayhem:fitment-ready', 'mayhem:collection-filter-updated'].forEach(name => window.addEventListener(name, () => { clearTimeout(resultTimer); resultTimer = setTimeout(results, 300); }));
  document.querySelectorAll('form[action*="/contact"]').forEach(form => form.addEventListener('submit', () => {
    if (!allowed()) return;
    try { sessionStorage.setItem('mayhem:inquiry-pending', String(Date.now())); } catch { /* Success is not counted without a matching submission. */ }
  }));
  const inquirySuccess = () => {
    if (!document.querySelector('[data-mayhem-inquiry-success]')) return;
    try {
      const pending = Number(sessionStorage.getItem('mayhem:inquiry-pending'));
      if (pending && Date.now() - pending < 30 * 60 * 1000 && allowed()) { track('generate_lead', { source: 'contact_form' }); sessionStorage.removeItem('mayhem:inquiry-pending'); }
    } catch { /* Storage unavailable. */ }
  };
  const watchSupportForm = () => {
    const containers = [...document.querySelectorAll('[data-forms-id="forms-root-1187712"]')];
    if (!containers.length) return;
    const records = new Set();
    const watched = new WeakSet();
    const scan = node => {
      if (node.shadowRoot) scan(node.shadowRoot);
      if (node.nodeType === 11 && !watched.has(node)) {
        watched.add(node);
        const record = { root: node, pending: 0, counted: false };
        records.add(record);
        node.addEventListener('submit', event => {
          if (event.target?.tagName !== 'FORM' || !event.isTrusted) return;
          record.pending = allowed() ? Date.now() : 0;
          record.counted = false;
        }, true);
        const check = () => {
          const success = node.querySelector('[data-current-step="success"]');
          if (!success || !record.pending || record.counted) return;
          const fresh = Date.now() - record.pending < 15 * 60 * 1000;
          record.pending = 0;
          record.counted = true;
          if (fresh && allowed()) track('generate_lead', { source: 'shopify_forms_support' });
        };
        new MutationObserver(check).observe(node, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['data-current-step']
        });
        check();
      }
      for (const child of node.querySelectorAll('*')) if (child.shadowRoot) scan(child.shadowRoot);
    };
    const discover = () => containers.forEach(scan);
    containers.forEach(container => new MutationObserver(discover).observe(container, { childList: true, subtree: true }));
    document.addEventListener('visitorConsentCollected', () => {
      if (!allowed()) records.forEach(record => { record.pending = 0; });
    });
    discover();
    let attempts = 0;
    const timer = setInterval(() => { discover(); if (++attempts >= 60) clearInterval(timer); }, 1000);
    window.addEventListener('pagehide', () => clearInterval(timer), { once: true });
  };
  watchSupportForm();
  if (window.Shopify?.customerPrivacy) consent();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) consent(); });
  document.addEventListener('visitorConsentCollected', inquirySuccess);
  document.addEventListener('visitorConsentCollected', searchResults);
  window.addEventListener('mayhem:search-results', searchResults);
})();




